import {
    FUND_REQUESTS_LIST_INITIATED,
    FUND_REQUESTS_INITIATED,
    MERCHANT_FUND_REQUESTS_LIST_INITIATED,
    MERCHANT_FUND_REQUESTS_INITIATED,
    FUND_REQUESTS_LOADED,
    FUND_REQUESTS_FAILED,
    FUND_REQUESTS_LIST_LOADED,
    FUND_REQUESTS_COUNT_INITIATED,
    FUND_REQUESTS_COUNT_LOADED,
    FUND_REQUESTS_COUNT_FAILED,
    FUND_REQUEST_INVOICE_DOWNLOAD_INITIATED,
    FUND_REQUEST_INVOICE_DOWNLOAD_LOADED,
    FUND_REQUEST_INVOICE_DOWNLOAD_FAILED
  } from "../actions/MerchantFundRequestAction";
  
  const initialState = {
    listdata: [],
    merchantlistdata: [],
    data: [],
    merchantCount : {
      approved_filtered_amount: "0",
      approved_filtered_count: "0",
      approved_total_amount: "0",
      approved_total_count: "0",
      
      initiated_filtered_amount: "0",
      initiated_filtered_count: "0",
      initiated_total_amount: "0",
      initiated_total_count: "0",

      rejected_filtered_amount: "0",
      rejected_filtered_count: "0",
      rejected_total_amount: "0",
      rejected_total_count: "0",

      total_filtered_count: "0",
      total_filtered_amount: "0",
      total_count: "0",
      total_amount: "0"
      
    },
    pagination: {
      total: 0,
      page: 1,
      limit: 10,
      totalPages: 1,
      nextPage: null,
    },
    loading: false,
    downloading: false,
    error: null
  };
  
  const MerchantReducer = (state = initialState, action) => {
    switch (action.type) {
      case FUND_REQUESTS_LIST_INITIATED:
        return {
          ...state,
          data : {},
          loading: true,
          error: null,
        };
      case FUND_REQUESTS_LIST_LOADED:
        return {
          ...state,
          loading: false,
          data : {},
          merchantlistdata: action.payload.data,
          pagination: action.payload.pagination,
        };
        case MERCHANT_FUND_REQUESTS_LIST_INITIATED:
          return {
            ...state,
            data : {},
            loading: true,
            error: null,
          };
        case MERCHANT_FUND_REQUESTS_INITIATED:
          return {
            ...state,
            loading: false,
            data : {},
            merchantlistdata: action.payload.data,
            pagination: action.payload.pagination,
          };
      case FUND_REQUESTS_INITIATED:
        return { ...state, loading: true, error: null};
      case FUND_REQUESTS_LOADED:
        const updatedObj = Object.fromEntries(
            Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
        );
        return { ...state, loading: false, data: updatedObj };
      case FUND_REQUESTS_COUNT_INITIATED:
          return { ...state};
      case FUND_REQUESTS_COUNT_LOADED:
          return { ...state, merchantCount: action.payload };
      case FUND_REQUESTS_COUNT_FAILED:
          return { ...state };
      case FUND_REQUESTS_FAILED:
          return { ...state, loading: false, error: action.payload };
      case FUND_REQUEST_INVOICE_DOWNLOAD_INITIATED:
          return { ...state, downloading: true };
      case FUND_REQUEST_INVOICE_DOWNLOAD_LOADED:
          return { ...state, downloading: false };
      case FUND_REQUEST_INVOICE_DOWNLOAD_FAILED:
          return { ...state, downloading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default MerchantReducer;